export default __webpack_public_path__ + "static/media/rwx_order_img_paid.70b68a96.png";